export type TEventsTooltipProps = {
  className?: string;
  style?: React.CSSProperties;
  isActive: boolean;
  data: TDataType[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dateTime?: any;
  onClose?(): void;
};

export enum EEventStatusType {
  added = 'Added',
  removed = 'Removed',
  edited = 'Edited',
}

export interface TDataType {
  title: string;
  status: string;
}
